import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "work-schedule-skeleton",
      class: _setup.isMobile
        ? "work-schedule-skeleton--mobile"
        : "work-schedule-skeleton--desktop",
    },
    [_c(VSkeletonLoader, { attrs: { type: "text@14" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }